import { render, staticRenderFns } from "./pos-see-badge-modal.vue?vue&type=template&id=e8d623e4&"
import script from "./pos-see-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-see-badge-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports